/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import type {
  LastSimulationRecord,
  RecentComponentRecord,
  RecentConfigRecord,
} from '@poweralpha/common';
import { useQuery } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';
import { api } from '../api';
import type { QueryOptions } from '../react-components/queries';

export const useLastSimulationsQuery = (
  opts?: QueryOptions<Array<LastSimulationRecord>> & { limit?: number },
) =>
  useQuery<Array<LastSimulationRecord>>({
    queryKey: ['last-simulations', opts?.limit ?? 8],
    queryFn: () =>
      api.get('results/last-simulations', { searchParams: { limit: opts?.limit ?? 8 } }).json(),
    staleTime: minutesToMilliseconds(2),
    ...opts,
  });

export const useRecentConfigsQuery = (
  opts?: QueryOptions<Array<RecentConfigRecord>> & { limit?: number },
) =>
  useQuery<Array<RecentConfigRecord>>({
    queryKey: ['recent-configs', opts?.limit ?? 8],
    queryFn: () =>
      api.get('results/recent-configs', { searchParams: { limit: opts?.limit ?? 8 } }).json(),
    staleTime: minutesToMilliseconds(2),
    ...opts,
  });

export const useRecentComponentsQuery = (
  opts?: QueryOptions<Array<RecentComponentRecord>> & { limit?: number },
) =>
  useQuery<Array<RecentComponentRecord>>({
    queryKey: ['recent-components', opts?.limit ?? 10],
    queryFn: () =>
      api.get('results/recent-components', { searchParams: { limit: opts?.limit ?? 10 } }).json(),
    staleTime: minutesToMilliseconds(2),
    ...opts,
  });
